export enum AMPriorityEnum {
  Unset,
  W1 = 1,
  W2 = 2,
  W3 = 3,
  W4 = 4,
}
